module.exports = __webpack_public_path__ + "static/media/cocktail1.4f589db8.svg";